// ToggleContainer.tsx
import { Box, Button, Collapse } from '@mui/material';
import React from 'react';
import { AccordionHeader } from '../Headers/styles';

interface ToggleContainerProps {
    title: string;
    isOpen?: boolean;
    handleToggle?: () => void;
    children: React.ReactNode;
    sx?: object;
    isGrey?: boolean;
}

const ToggleContainer: React.FC<ToggleContainerProps> = ({ title, children, isOpen, handleToggle, sx, isGrey }) => {
    return (
        <>
            <Collapse in={isOpen}>
                <Box
                    sx={(theme) => {
                        const userSx = typeof sx === 'function' ? sx(theme) : sx || {};

                        return {
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            padding: '8px 16px 16px 16px',
                            backgroundColor: isGrey ? theme.palette?.accordion?.parent?.bg : '#FFFFFF',
                            ...userSx,
                        };
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                        <AccordionHeader sx={{ p: 0, flexGrow: 1, fontWeight: 400 }}>
                            {title}
                        </AccordionHeader>
                        {handleToggle && (
                            <Button onClick={handleToggle} sx={{ textTransform: 'none' }}>
                                Hide
                            </Button>
                        )}
                    </Box>
                    {children}
                </Box>
            </Collapse>
        </>
    );
};

export default ToggleContainer;
